import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import { SearchRounded } from "@mui/icons-material";
import { useTheme } from "@mui/material";

const Widget = props => {
  const { widgetLayout = "column" } = props;

  const theme = useTheme();

  return (
    <Grow in={true}>
      <Paper
        sx={{
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.commonground.contrastText,
          position: "relative",
          display: "flex",
          flexDirection: widgetLayout,
          overflowY: "hidden",
          overflowX: "hidden",
          boxShadow: "none",
          padding: theme.spacing(4),
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SearchRounded
          sx={{
            width: "50%",
            height: "50%",
            opacity: "50%",
          }}
        />
      </Paper>
    </Grow>
  );
};

export default Widget;
